import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {MobileViewService} from 'gelios-ng-admin-components';
import {ActivatedRoute} from '@angular/router';
import {ExecutorModel} from '../../models/executor.model';
import {DescriptionCardInfoComponent} from '../../../shared/card-view/description-card-info/description-card-info.component';
import {DescriptionCardImageModel, DescriptionCardInfo} from '../../../shared/card-view/description-card-info/description-card-info';
import {UnitImagesShort} from '../../../dashboard/monitoring/unit';
import {timestampToAge, timestampToDate, timestampToDateTime} from '../../../utility/timestamp-functions';
import {ImmutableListRepositoryService} from '../../../../lib/gelios-field/immutable-list-repository.service';
import {MainLightboxService} from '../../../layout/main-lightbox.service';
import {OrderPhotosLightboxService} from '../../../layout/order-photos-lightbox/order-photos-lightbox.service';
import {RouteLibraryService} from '../../../route/route-library.service';
import {UserLinkService} from '../../../user/user-link.service';
import {AuthorizationService} from '../../../authorization/authorization.service';

@Component({
  selector: 'app-executor-info',
  templateUrl: '../../../shared/card-view/description-card-info/description-card-info.component.html',
  styleUrls: ['../../../shared/card-view/description-card-info/description-card-info.component.scss'],
})
export class ExecutorInfoComponent extends DescriptionCardInfoComponent implements OnInit {
  info: DescriptionCardInfo;
  modelData: ExecutorModel;
  imageSrc: DescriptionCardImageModel;
  imagesShort: Array<UnitImagesShort> = null;

  @Input() set model(model: ExecutorModel) {
    this.modelData = model;
    this.info = {
      columnFirst: [
        {
          iconName: 'ic-birth',
          title: 'Birth date',
          value: () => {
            const birthDate = this.getValidValue(model.birth_date_timestamp);
            return birthDate ? timestampToDate(birthDate) + ' - ' + timestampToAge(birthDate, this.translates) : '';
          }
        },
        {
          iconName: 'ic_phone',
          title: 'Phone',
          value: () => {
            return this.getValidValue(model.login);
          }
        },
        {
          iconName: 'ic-mail',
          title: 'E-mail',
          value: () => {
            return this.getValidValue(model.email);
          }
        },
      ],
      columnSecond: [
        {
          iconName: 'ic-registration',
          title: 'Registration date',
          value: () => {
            return model.registration_date_timestamp ? timestampToDateTime(model.registration_date_timestamp) : '';
          }
        },
        this.phoneManufacturerAndModel({
          request_device_vendor: model.last_request_device_vendor,
          request_device_model: model.last_request_device_model
        }),
        this.operatingSystemAndVersion({
          last_request_os_type: model.last_request_os_type,
          request_os_version: model.last_request_os_version,
        }),
        this.mobileApplicationAndItsVersion({
          project_name: model.projectName,
          request_os_type: model.last_request_os_type,
          request_client_version: model.last_request_client_version,
        }),
      ]
    };
  }

  constructor(
    protected translates: TranslateService,
    protected immutableListRepositoryService: ImmutableListRepositoryService,
    protected mainLightboxService: MainLightboxService,
    protected http: HttpClient,
    protected orderPhotosLightboxService: OrderPhotosLightboxService,
    protected routeLibrary: RouteLibraryService,
    protected mobileView: MobileViewService,
    protected activatedRoute: ActivatedRoute,
    protected userLinkService: UserLinkService,
    protected authorizationService: AuthorizationService,
  ) {
    super(
      immutableListRepositoryService,
      mainLightboxService,
      http,
      orderPhotosLightboxService,
      translates,
      routeLibrary,
      userLinkService,
      authorizationService
    );
  }

  ngOnInit() {
    if (!this.mobileView.mobileViewEnabled) {
      this.imageSrc = this.modelData.executor_photo ? {
        image: 'data:image/jpeg;base64,' + this.modelData.executor_photo,
        title: 'Image',
      } : {
        image: 'assets/img/user.svg',
        title: 'No executor photo',
      };
    }
  }
}
